import { AgentMessage } from "./agent.types";

export interface WebSocketMessage<T> {
    action: string;
    data: T;
}

export type ConnectionStatus = "Connecting" | "Open" | "Closing" | "Closed" | "Uninstantiated";

export interface AgentRequest {
    prompt: string;
    clientId: number;
    dashboardId: number;
    pageId: number;
    tag?: string;
    sessionId?: string;
    userId?: string;
    publishedToAll?: boolean;
}

export interface WebSocketState {
    connectionStatus: ConnectionStatus;
    isConnected: boolean;

    messages: GenericWebSocketMessage[];
    lastMessage: GenericWebSocketMessage | null;

    error: string | null;

    reconnectAttempts: number;
    maxReconnectAttempts: number;
}

export type WebSocketAction =
    | { type: "CONNECTION_STATUS_CHANGED"; payload: ConnectionStatus }
    | { type: "MESSAGE_RECEIVED"; payload: GenericWebSocketMessage }
    | { type: "ERROR_OCCURRED"; payload: string }
    | { type: "CLEAR_MESSAGES"; payload: (message: GenericWebSocketMessage) => boolean }
    | { type: "RECONNECT_ATTEMPT" }
    | { type: "RESET_RECONNECT_ATTEMPTS" };

export interface WebSocketConfig {
    url: string;
    protocols?: string | string[];
    options?: {
        heartbeat?: {
            message?: string;
            returnMessage?: string;
            timeout?: number;
            interval?: number;
        };
        shouldReconnect?: (closeEvent: CloseEvent) => boolean;
        reconnectInterval?: number;
        reconnectAttempts?: number;
    };
}

export interface GenericWebSocketMessage {
    action: string;
    data: AgentMessage;
    timestamp?: number;
}

export * from "./agent.types";
export * from "./page-insights.types";
export * from "./widget-insights.types";
export * from "./widget-recommendations.types";
export * from "./edit-widget.types";
export * from "./edit-widget-v2.types";
